var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgH4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8118 9.12508H20.7755V15.8438H36V11.3647C36 10.1377 35.0223 9.12508 33.8118 9.12508ZM3.18823 9.12508C1.97772 9.12508 1 10.1257 1 11.3647V15.8438H16.3176V9.12508H3.18823ZM3.18823 18.0834V33.7604C3.18823 34.9993 4.16595 36 5.37645 36H16.3176V18.0834H3.18823ZM31.6235 36C32.8341 36 33.8118 34.9993 33.8118 33.7604V18.0834H20.7755V36H31.6235ZM18.5058 6.87359C18.5175 6.87359 18.5175 6.88551 18.5175 6.89742H27.2704C30.2966 6.89742 31.6468 5.34878 31.6468 3.45467C31.6468 1.56056 30.285 0.0119127 27.2704 0.0119127C24.442 0.0119127 22.2188 1.34613 20.7057 2.89477C19.3555 2.02515 17.6445 2.01324 16.2827 2.84712C14.7695 1.31039 12.558 0 9.75291 0C6.72664 0 5.37645 1.54864 5.37645 3.44275C5.37645 5.33686 6.72664 6.88551 9.75291 6.88551H18.5058V6.87359ZM29.4353 3.53805C29.4353 4.46724 28.2481 4.65784 27.2471 4.65784H22.277C22.2654 4.6221 22.2421 4.59828 22.2305 4.56254C23.3479 3.45467 25.0239 2.41827 27.2471 2.41827C28.2481 2.41827 29.4353 2.60887 29.4353 3.53805ZM7.56468 3.53805C7.56468 2.60887 8.75191 2.41827 9.75291 2.41827C11.9295 2.41827 13.5823 3.41893 14.6881 4.47915C14.6531 4.53872 14.6299 4.59828 14.5949 4.65784H9.75291C8.75191 4.65784 7.56468 4.45533 7.56468 3.53805Z",
    fill: "#FE7320"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH4);
export default __webpack_public_path__ + "static/media/h4.338d493321efddb4944dff2194ef71eb.svg";
export { ForwardRef as ReactComponent };